/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 同乗実習生区分
 */
export type BaseInfoAmbulanceWithTrainingEnum =
  (typeof BaseInfoAmbulanceWithTrainingEnum)[keyof typeof BaseInfoAmbulanceWithTrainingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoAmbulanceWithTrainingEnum = {
  MEDICAL_STUDENT: 'MEDICAL_STUDENT',
  DEFENSE_FORCES: 'DEFENSE_FORCES',
} as const;
